export const useCmsBreadcrumb = () => {
	const { t } = useI18n();
	const localePath = useLocalePath();
	const requestURL = useRequestURL();
	const domain = computed(() => requestURL.origin);
	const route = useRoute();

	const slugToTitle = (slug: string) =>
		slug
			.split("-")
			.map((w: string) => w.charAt(0).toUpperCase() + w.slice(1))
			.join(" ");

	const buildCmsBreadcrumbItems = (
		storyName?: string | null
	): { position: number; name: string; item: string }[] => {
		const slug = route.params.slug;
		const slugParts = Array.isArray(slug) ? slug : slug ? [slug] : [];
		const homeNode = {
			position: 1,
			name: t("Home"),
			item: `${domain.value}${localePath("/")}`
		};
		if (!slugParts.length) return [homeNode];
		return [
			homeNode,
			...slugParts.map((part, i) => ({
				position: i + 2,
				name:
					i === slugParts.length - 1
						? storyName || slugToTitle(part)
						: slugToTitle(part),
				item: `${domain.value}${localePath("/" + slugParts.slice(0, i + 1).join("/"))}`
			}))
		];
	};

	return { buildCmsBreadcrumbItems };
};
